import React from "react";
import useToggle from "hooks/useToggle";
import "../Filter.scss";
import icondown from "assets/icons/search/icon-down.svg";
interface FilterContainerProps {
  children: React.ReactNode;
  title: string;
}
const FilterContainer: React.FC<FilterContainerProps> = ({
  children,
  title,
}) => {
  const [filterToggle, toggleFilter] = useToggle();
  return (
    <>
      <li className="refine__section">
        <div className="refine__heading" onClick={toggleFilter}>
          <div className={`refine__heading-content`}>{title}</div>
          <img src={icondown} className={`chevron ${filterToggle ? 'open' : 'close'}`} alt="chevron"></img>
        </div>

        <div className={`refine__content ${filterToggle ? 'collapsed' : '' } ${title === "AMENITIES" ? 'amenities-dd' : ''}`}>{children}</div>
      </li>
    </>
  );
};

export default FilterContainer;
